import eruda from "eruda";
import { isPC } from './index';

window.onload=() => {
  const isDev = !import.meta.env.MODE?.includes('production');
  const search = window.location.search;
  const makerKey = /joymaker/g
  if (!isPC() && isDev) {
    eruda.init();
  } else if (makerKey.test(search)) {
    eruda.init();
  }
};